// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqSquareFilledSvg from "@fishx/icons-svg/es/asn/QqSquareFilled";
import FishxIcon from '../components/FishxIcon';

var QqSquareFilled = function QqSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqSquareFilledSvg
  }));
};

QqSquareFilled.displayName = 'QqSquareFilled';
export default React.forwardRef(QqSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QqSquareFilled.js
// module id = 3948
// module chunks = 0